import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { CSSProperties, memo } from 'react';

import { AnyBlock } from '../types';
import { ComponentRenderer } from './ComponentRenderer';
import { BlockControls } from './Controls';

interface BuilderItemProps {
  block: AnyBlock;
  isDragging?: boolean;
  isOverlay?: boolean;
}

export const BuilderItem = memo<BuilderItemProps>(
  ({ block, isDragging = false, isOverlay = false }) => {
    const { attributes, listeners, setNodeRef, transform, transition } =
      useSortable({
        id: block.id,
        data: {
          type: 'block',
          block,
        },
      });

    const style: CSSProperties = {
      position: 'relative' as const,
      transform: CSS.Transform.toString(transform),
      transition,
      opacity: isDragging ? 0 : isOverlay ? 0.75 : 1,
    };

    return (
      <div
        ref={setNodeRef}
        style={style}
        {...attributes}
        role="group"
        data-testid={`builder-item-${block.id}`}
      >
        <ComponentRenderer block={block} isDragging={isDragging || isOverlay} />
        <BlockControls
          block={block}
          component={block.component}
          dragHandleProps={listeners}
        />
      </div>
    );
  },
);
